<div class="snippet-container">

	<div>
		<img [ngClass]="[snippet.paddingH, snippet.paddingV, snippet.backgroundColour]" [src]="snippet.content" class="img-fluid" />
	</div>
	<div class="text-end mt-2">
		<button class="btn btn-sm btn-danger" (click)="deleteConfirm()">Remove</button>
		<button class="btn btn-sm btn-primary ms-2" (click)="editSnippet()">Edit</button>
		<button class="btn btn-sm btn-primary ms-2" (click)="viewImageLibrary('cms')">Change image</button>
	</div>
</div>

<app-images *ngIf="showImageLibrary" [ownerId]="'cms'" [type]="imageLibraryType" [allowSelection]="false" (modalAction)="modalAction($event)" (imageSelected)="imageSelected($event)"></app-images>
<app-confirmation *ngIf="this.confirmationData.open" (complete)="confirmAction($event)" [data]="confirmationData"></app-confirmation>
<app-snippet-edit [snippet]="snippet" (modalAction)="editModalAction($event)" *ngIf="snippetEditModal"></app-snippet-edit>
